// extracted by mini-css-extract-plugin
module.exports = {"word":"TextWord_word__mvLd7","UthmanicHafs":"TextWord_UthmanicHafs__9DRAC","IndoPak":"TextWord_IndoPak__Vois6"};